import OffersService from '~/services/OffersService';
import VendorsService from '~/services/VendorsService';

import { isSalesforceOpportunityId, isValidSalesforceId } from '~/utils/validateSalesforceId';

// Resolves a Salesforce ID to its owning vendor:
// - Account IDs (001…) → fetched directly
// - Opportunity / offer IDs (006…) → resolved via the offer's vendor_account_id
// Returns null when the ID isn't a valid SF ID or the vendor can't be found.
export async function resolveVendorBySalesforceId(id: string): Promise<App.Vendor | null> {
  if (!isValidSalesforceId(id)) return null;

  let vendorSfid: string | undefined = id;
  if (isSalesforceOpportunityId(id)) {
    const offer = await OffersService.getOffer(id);
    vendorSfid = offer?.result?.vendor_account_id;
  }
  if (!vendorSfid) return null;

  const response = await VendorsService.getVendorById(vendorSfid);
  return response?.result ?? null;
}
